import { OrderPayment, OrderStatus } from '@digilize/shared/definitions/src';
import { CartSummaryOrderDto } from '@plys/src/infrastructure/dto/products.dto';

const PAYMENT_STATUS_PRIORITY: ReadonlyArray<string> = ['processing', 'paid'];

function rankPaymentStatus(status: string | null): number {
  const i = PAYMENT_STATUS_PRIORITY.indexOf(status ?? '');
  return i >= 0 ? i : Number.MAX_SAFE_INTEGER;
}

export function pickPaymentLink(payments: OrderPayment[] | undefined): string | null {
  const candidates = (payments ?? []).filter((p) => !!p.payment_url);
  if (!candidates.length) return null;
  return candidates
    .map((p, i) => ({ p, i }))
    .sort((a, b) => {
      const byRank = rankPaymentStatus(a.p.status) - rankPaymentStatus(b.p.status);
      return byRank !== 0 ? byRank : b.i - a.i;
    })[0].p.payment_url;
}

const REINIT_ORDER_STATUSES: ReadonlySet<OrderStatus> = new Set([
  OrderStatus.Processing,
  OrderStatus.PartiallyPaid,
  OrderStatus.Paid,
  OrderStatus.Unpaid,
  OrderStatus.PartiallyRefunded,
  OrderStatus.Delivered,
]);

export function findNewestOrder(orders: CartSummaryOrderDto[]): CartSummaryOrderDto | undefined {
  return orders
    .filter((order) => REINIT_ORDER_STATUSES.has(order.status))
    .sort((a, b) => (b.inserted ?? '').localeCompare(a.inserted ?? ''))[0];
}
